import { render, staticRenderFns } from "./ArchiveIcon.vue?vue&type=template&id=4cd002b6&scoped=true"
import script from "./ArchiveIcon.vue?vue&type=script&lang=js"
export * from "./ArchiveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd002b6",
  null
  
)

export default component.exports